// src/CookieBanner.tsx
import { useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const CONSENT_KEY = 'ring_cookie_notice_dismissed';

export function CookieBanner() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(CONSENT_KEY) === '1');

  if (dismissed) return null;

  function dismiss() {
    localStorage.setItem(CONSENT_KEY, '1');
    setDismissed(true);
  }

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie notice">
      <div className="cookie-banner-inner">
        <span className="cookie-banner-text">
          Shelfkin uses a single essential cookie to keep you signed in. No marketing or
          tracking cookies. <Link to="/privacy" className="cookie-banner-link">Privacy Policy</Link>
        </span>
        <button className="cookie-banner-btn" onClick={dismiss}>Got it</button>
      </div>
    </div>
  );
}
